import { createActionGroup, props } from '@ngrx/store';
import { PurchaseEventParams } from '../../modules/share/services/data-layer.service';

export const AnalyticsActions = createActionGroup({
  source: 'Analytics',
  events: {
    'Viewed Page': props<{
      eventName: string;
      input?: PurchaseEventParams;
    }>(),
    'Page Loaded': props<{ feature: string; target: string; error?: any }>(),
    'Trigger Button': props<{ feature: string; target: string }>(),
  },
});
